﻿import { isDesktop, isIOS } from '@SharedScripts/Utils/DeviceClass';

export const getOsType = () => {
  let os = 'web';
  if (isIOS()) {
    os = 'webios';
  } else if (!isDesktop()) {
    os = 'webandroid';
  }

  return os;
};